export default __webpack_public_path__ + "static/media/envlope.4b581c82.svg";